import { render, staticRenderFns } from "./jjReportIndex.vue?vue&type=template&id=1b3e3822&"
import script from "./jjReportIndex.vue?vue&type=script&lang=js&"
export * from "./jjReportIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports